export default class Float {
    public static floatToIntBits(f: number): number {
        return f;
    }
}



// WEBPACK FOOTER //
// ./src/core/util/Float.ts